import { asPercent } from "@silo/utils";
import { Align, Breakdown } from "./components";
import { Percent, PositionReward } from "@silo/types";

interface BreakdownCollateralProps {
  className?: string;
  collateralBaseApr: Percent;
  collateralRewards: PositionReward[];
  align: Align;
}

export function BreakdownCollateral({
  className,
  collateralBaseApr,
  collateralRewards,
  align,
}: BreakdownCollateralProps): JSX.Element {
  return (
    <Breakdown.Root className={className} align={align}>
      <Breakdown.Item>
        <Breakdown.ItemValue>
          {asPercent(collateralBaseApr)}
        </Breakdown.ItemValue>

        <Breakdown.ItemLabel>deposit APR</Breakdown.ItemLabel>
      </Breakdown.Item>

      {collateralRewards.map((reward) => (
        <Breakdown.DepositRewardItem reward={reward} />
      ))}
    </Breakdown.Root>
  );
}
